<div class="flex-fill d-flex dx-card">
  <div [class]="(showAsComponent ? '' : '') + ' d-flex flex-column flex-fill col-sm-6'">
    @if (!showAsComponent) {
      <h4>Open Invoices</h4>
    }
    <div class="d-flex flex-column flex-fill p-1">
      <dx-data-grid
        #openInvoicesDataGrid
        keyExpr="id"
        class="flex-fill d-flex flex-column"
        height="100px"
        [dataSource]="invoices"
        [showBorders]="true"
        (onRowDblClick)="onRowDoubleClick($event)"
        [columnAutoWidth]="false"
        >
        <dxi-column dataField="id" caption="Id" width="75" cellTemplate="invoiceLinkTemplate"></dxi-column>
        <dxi-column dataField="invoiceNumber" caption="Invoice #" width="75" cellTemplate="invoiceLinkTemplate"></dxi-column>
        <dxi-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
        <dxi-column dataField="unpaidBalance" caption="Balance" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
        <dxi-column dataField="customer.displayName" caption="Customer" width="175" cellTemplate="customerLinkTemplate"></dxi-column>
        <dxi-column dataField="displayBillAddress" caption="Billing Address"></dxi-column>

        <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
          @if (cell && isPaymentAdmin) {
            <a [routerLink]="'/invoices/' + cell.data.id" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isPaymentAdmin) {
            <div [innerHtml]="cell.text"></div>
          }
        </div>

        <div *dxTemplate="let cell of 'customerLinkTemplate'">
          @if (cell && isPaymentAdmin) {
            <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
          }
          @if (cell && !isPaymentAdmin) {
            <div [innerHtml]="cell.text"></div>
          }
        </div>

        <div *dxTemplate="let data of 'toolbarButtons'">
          @if (!showAsComponent) {
            <span>
              <button
                class="btn btn-success me-3 mb-2"
                (click)="receivePayment()"
                [disabled]="openInvoicesDataGrid.instance.getSelectedRowsData().length === 0"
                [hidden]="!isPaymentAdmin"
                >
                Receive Payment
              </button>
              <button
                class="btn btn-sm btn-primary me-1 mb-2"
                (click)="applyCredit()"
                [disabled]="openInvoicesDataGrid.instance.getSelectedRowsData().length === 0"
                [hidden]="!isPaymentAdmin"
                >
                Apply Credit
              </button>
            </span>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (invoices) {
            <span class="me-3">
              <strong>{{ openInvoicesDataGrid.instance.totalCount() + " items" }}</strong>
            </span>
          }
        </div>

        <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'single'"></dxo-selection>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payment-invoice-overview-grid"></dxo-state-storing>
      </dx-data-grid>
    </div>
  </div>
  @if (!showAsComponent) {
    <div class="d-flex flex-fill flex-column col-sm-6">
      <div class="d-flex flex-column flex-fill p-1">
        <h4>Payments</h4>
        <dx-data-grid
          #dataGrid
          [keyExpr]="'id'"
          class="flex-fill d-flex flex-column"
          height="100px"
          [dataSource]="payments"
          [showBorders]="true"
          (onRowDblClick)="onPaymentDoubleClick($event)"
          [columnAutoWidth]="true"
          >
          <dxi-column dataField="id" width="75"></dxi-column>
          <dxi-column dataField="customer.companyName" caption="Customer" width="150" cellTemplate="customerLinkTemplate"></dxi-column>
          <dxi-column dataField="paymentDate" caption="Date" width="75"></dxi-column>
          <dxi-column dataField="paymentMethod.name" caption="Method" width="75"></dxi-column>
          <dxi-column dataField="paymentAmount" caption="Amount" [format]="{ type: 'currency', precision: 2 }" width="75"></dxi-column>
          <dxi-column dataField="referenceNumber" caption="Ref#" width="75"></dxi-column>
          <dxi-column dataField="quickBooksId" caption="QB ID" width="75"></dxi-column>
          <dxi-column dataField="quickBooksLastExport" caption="QB Export" width="75"></dxi-column>
          <dxi-column caption="Invoices" cellTemplate="invoiceLinksTemplate"></dxi-column>
          <!-- <dxi-column dataField="created" dataType="date" width="100"></dxi-column> -->
          <!-- <dxi-column dataField="createdBy" width="100"></dxi-column> -->
          <div *dxTemplate="let cell of 'customerLinkTemplate'">
            @if (cell && isPaymentAdmin) {
              <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
            }
            @if (cell && !isPaymentAdmin) {
              <div [innerHtml]="cell.text"></div>
            }
          </div>
          <div *dxTemplate="let cell of 'invoiceLinksTemplate'" class="links-template">
            @for (invoice of cell.data.invoices; track invoice.id) {
              <a [routerLink]="'/invoices/' + invoice.id">{{ invoice.invoiceNumber }}</a>
            }
          </div>
          <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-selection mode="multiple"></dxo-selection>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payments-grid"></dxo-state-storing>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button
              class="btn btn-primary me-1 mb-2"
              (click)="openPayment(dataGrid.instance.getSelectedRowsData()[0]?.id)"
              [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isPaymentAdmin"
              >
              Open
            </button>
            <button
              class="btn btn-danger me-3 mb-2"
              (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
              [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
              [hidden]="!isPaymentAdmin"
              >
              Delete
            </button>
            <button
              class="btn btn-secondary me-1 mb-2"
              (click)="payWithoutQuickBooks(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="
                            dataGrid.instance.getSelectedRowsData().length !== 1 ||
                            dataGrid.instance.getSelectedRowsData()[0].quickBooksId ||
                            dataGrid.instance.getSelectedRowsData()[0].quickBooksExport
                        "
              [hidden]="!isPaymentAdmin"
              >
              Pay w/o QuickBooks
            </button>
            <!-- <button
            class="btn btn-secondary me-1 mb-2"
            (click)="printPaymentReceipt(dataGrid.instance.getSelectedRowsData())"
            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
            [hidden]="!isPaymentAdmin"
            >
            Print
          </button> -->
          <!-- <button
          class="btn btn-secondary mb-2"
          (click)="emailPaymentReceipt(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          [hidden]="!isPaymentAdmin"
          >
          Email
        </button> -->
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (payments) {
          <span class="me-3">
            <strong>{{ dataGrid.instance.totalCount() + " items" }}</strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
}
</div>
